import moment from "moment";
import { h5CosTempToken } from "../../utils/api.js";

// 定义上传类型
let uploadType = 'cos'; // cos:腾讯云存储 local: 本地存储 oss：oss存储

// npm i cos-js-sdk-v5 --save
let COS = require('cos-js-sdk-v5');

/**
 * 使用服务端下发的临时密钥初始化 COS。
 * 临时密钥仅含 PutObject，且仅允许上传到 feedback/{userId}/* 。
 */
let cos = new COS({
	getAuthorization: function (options, callback) {
		h5CosTempToken({}).then((res) => {
			const data = res && res.data;
			if (!data || !data.tmpSecretId || !data.tmpSecretKey || !data.sessionToken) {
				console.error('credentials invalid', data);
				return;
			}
			callback({
				TmpSecretId: data.tmpSecretId,
				TmpSecretKey: data.tmpSecretKey,
				SecurityToken: data.sessionToken,
				// 使用服务端时间，避免客户端时钟偏差导致签名失败
				StartTime: data.startTime,
				ExpiredTime: data.expiredTime,
				// 细粒度权限：同一组密钥仅可重复用于相同 scope 的请求
				ScopeLimit: true,
			});
		}).catch((err) => {
			console.error('getAuthorization failed', err);
		});
	}
});

const DEFAULT_BUCKET = 'brazil-1314092171';
const DEFAULT_REGION = 'sa-saopaulo';

function buildUploadKey(file, allowPrefix) {
	const userId = sessionStorage.getItem('userId') || '0';
	const prefix = allowPrefix || ('feedback/' + userId + '/');
	const safeName = String(file.name || 'img').replace(/[^a-zA-Z0-9._-]/g, '_');
	return prefix + moment().format('YYYYMMDD') + '/' + Date.now() + '_' + safeName;
}

// 上传：putObject 简单上传（与 STS 仅授权 PutObject 一致）
export function cosUploadFile(file) {
	const userId = sessionStorage.getItem('userId') || '0';
	const fileName = buildUploadKey(file, 'feedback/' + userId + '/');
	try {
		return new Promise((resolve, reject) => {
			cos.putObject({
				Bucket: DEFAULT_BUCKET,
				Region: DEFAULT_REGION,
				Key: fileName,
				StorageClass: 'STANDARD',
				Body: file,
				onProgress: function (progressData) {
					// console.log(JSON.stringify(progressData));
				}
			}, function (err, data) {
				if (!data || data.statusCode != 200) {
					reject('');
				} else {
					resolve('https://' + data.Location);
				}
			});
		});
	} catch (err) {
		// console.log(err,'11')
	}
}
